import { useTangerineApi } from 'domains/tangerine/hooks'
import { useContext } from 'react'
import { PatientContext } from 'ui/contexts'

const useClinicalVisit = ({ clinicalVisitId }) => {
  const { id: patientId } = useContext(PatientContext) || {}

  const { data, errors, loading } = useTangerineApi({
    path: `/api/v3/patients/${patientId}/clinical_visits/${clinicalVisitId}`,
    method: 'GET',
  })

  return {
    data: data?.data || {},
    loading,
    hasError: !!(errors && errors.length),
  }
}

export default useClinicalVisit
